function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M6.77 13.538C3.045 13.538 0 10.492 0 6.77 0 3.046 3.046 0 6.77 0c3.722 0 6.768 3.046 6.768 6.77 0 3.722-3.046 6.768-6.769 6.768zm0-12.41c-3.103 0-5.642 2.539-5.642 5.641 0 3.103 2.539 5.641 5.641 5.641 3.103 0 5.641-2.538 5.641-5.64 0-3.103-2.538-5.642-5.64-5.642zm0 9.59c-.34 0-.565-.226-.565-.564V6.205c0-.338.226-.564.564-.564.339 0 .564.226.564.564v3.949c0 .282-.225.564-.564.564zm0-7.503c.338 0 .62.282.62.62 0 .34-.282.621-.62.621-.34 0-.621-.282-.621-.62 0-.339.282-.62.62-.62z",
  transform: "translate(-861 -370) translate(560 128) translate(301 242) translate(1.23 1.23)"
}))))));

var SvgIconInfo = function SvgIconInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-info.b0cac4b9.svg";
export { ForwardRef as ReactComponent };